<template>
  <div>
    <h1 class="mt-2 mb-4">{{ viewer.name }}</h1>
    <div class="mess-box" v-if="viewer.description">{{ viewer.description }}</div>
    <p v-if="error" role="alert" class="viewer-error">{{ error }} <button @click="load">Повторить</button></p>
    <div id="viewer" style="width:100%;height:min(75vh,720px);min-height:360px"></div>
  </div>
</template>
<script>
import http from '@/http';
import {unavailableViewerIds} from '@/utils/publicCatalog';
import OpenSeadragon from 'openseadragon';
export default {
  props: ['id'],
  data() { return {viewer: {}, error: '', microscope: null}; },
  mounted() { this.load(); },
  beforeUnmount() { this.microscope?.destroy(); },
  watch: {id() {this.load();}},
  methods: {
    async load() {
      this.error = '';
      this.microscope?.destroy();
      if (unavailableViewerIds.has(this.id)) {this.viewer = {}; this.error = 'Этот препарат временно снят с публикации. Выберите другой препарат в каталоге.'; return;}
      try {
        const {data} = await http.get(`viewer/${this.id}`);
        this.viewer = data;
        const name = String(data.file_name || '') + '.dzi';
        this.microscope = OpenSeadragon({id:'viewer',showNavigator:true,prefixUrl:'/images/',tileSources:`/slides/${encodeURIComponent(name)}`});
        this.microscope.addHandler('open-failed', () => {this.error = 'Изображение препарата недоступно. Попробуйте позже или выберите другой препарат.';});
      } catch { this.error = 'Не удалось загрузить препарат. Проверьте соединение и повторите попытку.'; }
    }
  }
};
</script>
<style scoped>
#viewer {background:#edf1f3;border:1px solid #d5dfe5;border-radius:10px;}
.viewer-error {padding:16px;background:#fff3ef;color:#803525;}
</style>
